module.exports = __webpack_public_path__ + "img/GDQ-White.9a050195.svg";